import React from 'react';

import { BrandedCreditCardInfoTypeLabel } from './constants';
import ITAModalContent from './ITAModalContent';
import PreApprovedModalContent from './PreApprovedModalContent';

interface SunbitModalContentProps {
  eligibleVariant?: string;
  firstName?: string;
  offerAmount?: string;
  onCTAClick?: () => void;
}

export default function SunbitModalContent({
  eligibleVariant,
  firstName,
  offerAmount,
  onCTAClick,
}: SunbitModalContentProps) {
  const isPreapproved =
    eligibleVariant === BrandedCreditCardInfoTypeLabel.PRE_APPROVED;

  if (isPreapproved) {
    return (
      <PreApprovedModalContent
        firstName={firstName}
        offerAmount={offerAmount}
        onCTAClick={onCTAClick}
      />
    );
  }

  return <ITAModalContent firstName={firstName} onCTAClick={onCTAClick} />;
}
